import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImageRotationService {
  private rotationSubject = new BehaviorSubject<{ url: string; index: number }>(null);
  rotation$ = this.rotationSubject.asObservable();

  updateRotatedImageURL(newURL: string, slideIndex: number): void {
    this.rotationSubject.next({ url: newURL, index: slideIndex });
  }
}
